export function setLS(key, value) {
  const data = typeof value === "string" ? value : JSON.stringify(value);
  localStorage.setItem(key, data);
}

export function getLS(key) {
  const data = localStorage.getItem(key);
  try {
    return JSON.parse(data);
  } catch {
    return data;
  }
}
